/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BellIcon = /*#__PURE__*/ createSvgIcon(
  'BellIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            d="M7.93 15.5c-.5 0-1-.18-1.38-.53-.63-.58-.76-1.5-.33-2.22l.15-.25h3.12l.15.24c.44.73.3 1.65-.33 2.23-.39.35-.88.53-1.38.53zm-.94-2c-.06.26.03.54.24.74.38.35 1.02.35 1.39 0 .22-.2.3-.47.25-.74H6.99z"
            fill="currentColor"
          />
          <path
            d="M13.56 13.5H2.45v-1.48c0-1.37.68-2.14 1.23-2.75.41-.46.66-.77.67-1.16V6.17c0-1.99 1.7-3.67 3.71-3.67 1.99 0 3.6 1.64 3.6 3.67v1.95c0 .39.26.69.67 1.15.55.62 1.23 1.38 1.23 2.75v1.48zm-10.11-1h9.11v-.48c0-.99-.47-1.52-.98-2.09-.45-.5-.91-1.02-.92-1.81V6.17C10.67 4.7 9.5 3.5 8.06 3.5c-1.44 0-2.71 1.25-2.71 2.67v1.95c-.01.79-.48 1.31-.92 1.81-.51.57-.98 1.11-.98 2.09v.48z"
            fill="currentColor"
          />
          <path
            d="M8.06 3.5c-.28 0-.5-.22-.5-.5V1c0-.28.22-.5.5-.5s.5.22.5.5v2c0 .28-.22.5-.5.5z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 .4a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2a.5.5 0 01.5-.5zM7.88 15.4h4.07l.145.253a2.5 2.5 0 01.304 1.576c-.112.818-.712 1.628-1.398 2.032a2.503 2.503 0 01-3.27-3.662l.15-.199zm.523 1a1.502 1.502 0 002.09 2c.455-.268.85-.828.915-1.307a1.5 1.5 0 00-.068-.693H8.403z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.12 6.78C5.12 4.026 7.429 2.4 10 2.4c2.571 0 4.88 1.626 4.88 4.38v3.117c.007.627.358.963.945 1.527l.221.213c.338.328.708.723.989 1.252.284.535.465 1.183.465 2.011v1.5h-15v-1.5c0-.828.18-1.476.465-2.011.281-.53.651-.924.989-1.252l.22-.213c.588-.564.939-.9.946-1.527V6.78zM10 3.4c-2.189 0-3.88 1.334-3.88 3.38v3.125c-.011 1.078-.696 1.72-1.259 2.249-.072.068-.143.134-.21.2-.315.306-.596.614-.803 1.004-.204.383-.348.87-.348 1.542v.5h13v-.5c0-.672-.144-1.159-.348-1.542-.207-.39-.488-.698-.803-1.005l-.21-.2c-.563-.528-1.248-1.17-1.259-2.248V6.78c0-2.046-1.691-3.38-3.88-3.38z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 .4a.5.5 0 01.5.5v3a.5.5 0 01-1 0v-3a.5.5 0 01.5-.5zM9.96 19.4h4.07l.145.253a2.5 2.5 0 01-.388 2.987 2.503 2.503 0 01-3.976-3.04l.15-.2zm3.098 2.555a1.5 1.5 0 00.362-1.555h-2.937a1.503 1.503 0 002.528 1.61l.047-.055z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3.4a5.35 5.35 0 015.5 5.508V11.9c0 .934.54 1.528 1.282 2.342l.088.097c.76.836 1.63 1.86 1.63 3.561v2.5h-17v-2.5c0-1.702.87-2.725 1.63-3.561l.088-.097C5.959 13.428 6.5 12.834 6.5 11.9V8.908A5.35 5.35 0 0112 3.4zm-.016 1A4.35 4.35 0 007.5 8.884V11.9c0 1.334-.798 2.204-1.485 2.953-.05.053-.098.106-.145.158-.74.814-1.37 1.59-1.37 2.889v1.5h15v-1.5c0-1.298-.63-2.075-1.37-2.889a42.018 42.018 0 00-.145-.158c-.687-.748-1.485-1.619-1.485-2.953V8.884A4.349 4.349 0 0012.016 4.4h-.032z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default BellIcon;
